import { render, staticRenderFns } from "./TimesIcon.vue?vue&type=template&id=19632c3c"
import script from "./TimesIcon.vue?vue&type=script&lang=ts"
export * from "./TimesIcon.vue?vue&type=script&lang=ts"
import style0 from "./TimesIcon.vue?vue&type=style&index=0&id=19632c3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports